import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function CompetenciesList() {
    const dispatch = useDispatch();

    const profileFilter = chooseProfileFilter();

    const navigate = useNavigate();

    const pathFrontEnd = '/gci/banking-histories/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllBankAccounts: `${endpointBackend}gci/bank-accounts/getall`,
        endpointDelete: `${endpointBackend}gci/banking-histories/delete`,
        endpoint: `${endpointBackend}gci/banking-histories/getbycompetency`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'gci_bank_account_id',
                type: 'select',
                label: 'Conta Bancária',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllBankAccounts,
                    label: 'full_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'month',
                type: 'select',
                label: 'Mês',
                options: [
                    { value: '01', label: 'Janeiro' },
                    { value: '02', label: 'Fevereiro' },
                    { value: '03', label: 'Março' },
                    { value: '04', label: 'Abril' },
                    { value: '05', label: 'Maio' },
                    { value: '06', label: 'Junho' },
                    { value: '07', label: 'Julho' },
                    { value: '08', label: 'Agosto' },
                    { value: '09', label: 'Setembro' },
                    { value: '10', label: 'Outubro' },
                    { value: '11', label: 'Novembro' },
                    { value: '12', label: 'Dezembro' }
                ],
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'year',
                type: 'year',
                selectable: true,
                label: 'Ano',
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Histórico de Transações',
        labelTitleButtonAdd: 'Importar Extrato',
        fieldsShowOnDelete: ['trnamt'],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canDelete: false,
        viewActionColumn: false,
        formFilters: filters,
        filter: {
            ...profileFilter,
        },
        columns: [
            {
                name: 'company_name',
                label: 'Empresa',
            },
            {
                name: 'bank_account_name',
                label: 'Conta Bancária',
            },
            {
                name: 'formatted_competency',
                label: 'Competência'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Visualizar',
                        icon: 'fas fa-eye',
                        onClick: async item => {
                            const banking_history_params = {
                                gci_company_id: item.gci_company_id,
                                gci_bank_account_id: item.gci_bank_account_id,
                                competency: item.competency
                            }

                            dispatch({ type: 'UPDATE_SESSION', key: 'banking_history_params', value: banking_history_params });
                            navigate(`/gci/banking-histories/list`)
                        },
                        width: '10%'
                    }
                ]
            }
        ],
        buttonsListContainer: [
            {
                name: 'files_banking_histories',
                class: 'btn btn-secondary',
                label: 'Importações',
                tooltipLabel: 'Verificar importações',
                callback: async () => {
                    navigate(`/gci/banking-histories/files`)
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default CompetenciesList;
